import type {
  WaitlistErrorResponse,
  WaitlistPayload,
  WaitlistResponse,
  WaitlistSuccessResponse,
} from '../types/waitlist';

const API_ENDPOINT = '/api/waitlist';

export async function submitWaitlist(
  payload: WaitlistPayload
): Promise<WaitlistSuccessResponse> {
  const response = await fetch(API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  const contentType = response.headers.get('content-type') || '';
  const isJsonResponse = contentType.toLowerCase().includes('application/json');

  if (!isJsonResponse) {
    const rawBody = await response.text();
    const isHtmlLike = rawBody.trim().startsWith('<!DOCTYPE') || rawBody.trim().startsWith('<html');
    const isLocalhost =
      typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);

    if (isHtmlLike && isLocalhost) {
      throw new Error('Local API route not available. Run with "npx vercel dev" or test on deployed URL.');
    }

    throw new Error('Unexpected server response. Please refresh and try again.');
  }

  const data = (await response.json()) as WaitlistResponse;

  if (!response.ok || !data.ok) {
    const message = (data as WaitlistErrorResponse).error || 'Unable to join waitlist.';
    throw new Error(message);
  }

  return data;
}
